export const semanticColors = {
  "alienblue-100": "#DCE2FB",
  "alienblue-200": "#B8C5FC",
  "alienblue-25": "#F7F8FD",
  "alienblue-300": "#90A9FD",
  "alienblue-400": "#648EFC",
  "alienblue-50": "#EEF0FB",
  "alienblue-500": "#1870F4",
  "alienblue-600": "#115BCA",
  "alienblue-700": "#0A449B",
  "alienblue-75": "#E6E9FB",
  "alienblue-800": "#0A2F6C",
  "alienblue-900": "#0A1A3F",
  "alienblue-950": "#07102B",
  "berrypurple-100": "#F3DAFB",
  "berrypurple-200": "#EAB3FD",
  "berrypurple-25": "#FBF6FD",
  "berrypurple-300": "#DE8BFF",
  "berrypurple-400": "#CF5FFF",
  "berrypurple-50": "#F8EDFC",
  "berrypurple-500": "#BC0EFF",
  "berrypurple-600": "#9B00D4",
  "berrypurple-700": "#7600A3",
  "berrypurple-75": "#F6E4FB",
  "berrypurple-800": "#520472",
  "berrypurple-900": "#300643",
  "berrypurple-950": "#20042A",
  "black": "#000000",
  "black-opacity-0": "#00000000",
  "black-opacity-10": "#00000019",
  "black-opacity-15": "#00000026",
  "black-opacity-20": "#00000033",
  "black-opacity-25": "#0000003F",
  "black-opacity-33": "#00000054",
  "black-opacity-5": "#0000000C",
  "black-opacity-50": "#0000007F",
  "black-opacity-60": "#00000099",
  "black-opacity-67": "#000000AA",
  "black-opacity-80": "#000000CC",
  "black-opacity-90": "#000000E5",
  "brand-secondary-bananayellow_base": "#FFBF0B",
  "brand-secondary-bananayellow_highlight": "#FFDE55",
  "brand-secondary-bananayellow_shade": "#F27300",
  "brand-secondary-bananayellow_tint": "#FFF3C0",
  "brand-secondary-guavapink_base": "#FF5FC2",
  "brand-secondary-guavapink_highlight": "#FF9FDF",
  "brand-secondary-guavapink_shade": "#D3168B",
  "brand-secondary-guavapink_tint": "#FFE6F9",
  "brand-secondary-juniperblue_base": "#00E2B7",
  "brand-secondary-juniperblue_highlight": "#92FFEA",
  "brand-secondary-juniperblue_shade": "#08A59D",
  "brand-secondary-juniperblue_tint": "#E6FFFA",
  "brand-secondary-limegreen_base": "#AEEF0F",
  "brand-secondary-limegreen_highlight": "#E4FF45",
  "brand-secondary-limegreen_shade": "#65B200",
  "brand-secondary-limegreen_tint": "#F0FFB3",
  "brand-secondary-orangered_base": "#FF4500",
  "brand-secondary-orangered_highlight": "#FF8864",
  "brand-secondary-orangered_shade": "#D82400",
  "brand-secondary-orangered_tint": "#FFDAD7",
  "brown-100": "#F1DFCF",
  "brown-200": "#E9BE95",
  "brown-25": "#FBF7F4",
  "brown-300": "#DC9D5D",
  "brown-400": "#BA854E",
  "brown-50": "#F7EFE9",
  "brown-500": "#9A6D3F",
  "brown-600": "#7B5631",
  "brown-700": "#5D4023",
  "brown-75": "#F4E7DC",
  "brown-800": "#3F2C19",
  "brown-900": "#221A11",
  "brown-950": "#15100A",
  "coolgray-100": "#DBE4E9",
  "coolgray-150": "#C9D7DE",
  "coolgray-200": "#B7CAD4",
  "coolgray-25": "#F6F8F9",
  "coolgray-250": "#A4BDCA",
  "coolgray-300": "#97AFBC",
  "coolgray-350": "#8BA2AD",
  "coolgray-400": "#7F949F",
  "coolgray-450": "#748791",
  "coolgray-50": "#EEF1F3",
  "coolgray-500": "#667780",
  "coolgray-525": "#576F76",
  "coolgray-550": "#5C6C74",
  "coolgray-600": "#536168",
  "coolgray-650": "#48545B",
  "coolgray-700": "#3D494E",
  "coolgray-75": "#E5EBEE",
  "coolgray-750": "#333D42",
  "coolgray-800": "#2A3236",
  "coolgray-850": "#21272A",
  "coolgray-900": "#181C1F",
  "coolgray-950": "#0E1113",
  "global-black": {
    "light": "#000000",
    "dark": "#000000"
  },
  "global-brand-orangered": {
    "light": "#FF4500",
    "dark": "#FF4500"
  },
  "global-white": {
    "light": "#FFFFFF",
    "dark": "#FFFFFF"
  },
  "kiwigreen-100": "#A8F5A0",
  "kiwigreen-200": "#58E15B",
  "kiwigreen-25": "#EBFDE7",
  "kiwigreen-300": "#00C61C",
  "kiwigreen-400": "#01A816",
  "kiwigreen-50": "#DDF8D7",
  "kiwigreen-500": "#008A10",
  "kiwigreen-600": "#016E0B",
  "kiwigreen-700": "#005306",
  "kiwigreen-75": "#CAF5C2",
  "kiwigreen-800": "#033902",
  "kiwigreen-900": "#0D2005",
  "kiwigreen-950": "#081404",
  "lightblue-100": "#CAE7FB",
  "lightblue-200": "#87D0FD",
  "lightblue-25": "#F3F9FD",
  "lightblue-300": "#02B9FB",
  "lightblue-400": "#029DD5",
  "lightblue-50": "#E6F3FC",
  "lightblue-500": "#007FAE",
  "lightblue-600": "#01668D",
  "lightblue-700": "#014D6B",
  "lightblue-75": "#D9EDFB",
  "lightblue-800": "#03354B",
  "lightblue-900": "#051E2B",
  "lightblue-950": "#04131A",
  "lime-100": "#B7F28E",
  "lime-200": "#90DA58",
  "lime-25": "#EEFDDC",
  "lime-300": "#6DBF01",
  "lime-400": "#5BA200",
  "lime-50": "#E0F8C8",
  "lime-500": "#4A8500",
  "lime-600": "#3A6A00",
  "lime-700": "#2A5000",
  "lime-75": "#CEF5AD",
  "lime-800": "#1E3702",
  "lime-900": "#151E05",
  "lime-950": "#0D1304",
  "mintgreen-100": "#9BF5D9",
  "mintgreen-200": "#00E2B7",
  "mintgreen-25": "#E7FDF5",
  "mintgreen-300": "#00C29D",
  "mintgreen-400": "#01A484",
  "mintgreen-50": "#D7F8EC",
  "mintgreen-500": "#01876D",
  "mintgreen-600": "#006C56",
  "mintgreen-700": "#015140",
  "mintgreen-75": "#C0F5E3",
  "mintgreen-800": "#00382B",
  "mintgreen-900": "#032019",
  "mintgreen-950": "#03140F",
  "orangered-100": "#FCDBCF",
  "orangered-200": "#FDB498",
  "orangered-25": "#FDF6F4",
  "orangered-300": "#FF895D",
  "orangered-400": "#FF4500",
  "orangered-50": "#FCEEE8",
  "orangered-500": "#D93900",
  "orangered-600": "#AE2C00",
  "orangered-700": "#842100",
  "orangered-75": "#FBE5DC",
  "orangered-800": "#591B02",
  "orangered-900": "#2F1405",
  "orangered-950": "#1C0D04",
  "periwinkle-100": "#E6DFFB",
  "periwinkle-200": "#CDBEFD",
  "periwinkle-25": "#F9F7FD",
  "periwinkle-300": "#B29FFF",
  "periwinkle-400": "#9580FF",
  "periwinkle-50": "#F2EFFC",
  "periwinkle-500": "#6A5CFF",
  "periwinkle-600": "#523DFF",
  "periwinkle-700": "#4001EA",
  "periwinkle-75": "#ECE7FB",
  "periwinkle-800": "#250AA6",
  "periwinkle-900": "#160E5B",
  "periwinkle-950": "#0C083F",
  "poopbrown-100": "#FEEEDD",
  "poopbrown-200": "#F6DDC3",
  "poopbrown-300": "#EECCAA",
  "poopbrown-400": "#CAA075",
  "poopbrown-50": "#FEF7EE",
  "poopbrown-500": "#9A6D3F",
  "poopbrown-600": "#6E4924",
  "poopbrown-700": "#54371A",
  "poopbrown-800": "#3B2510",
  "poopbrown-900": "#29190A",
  "poopbrown-950": "#110B04",
  "puregray-100": "#F2F2F2",
  "puregray-150": "#EBEBEB",
  "puregray-200": "#E4E4E4",
  "puregray-250": "#DDDDDD",
  "puregray-300": "#D6D6D6",
  "puregray-350": "#C3C3C3",
  "puregray-400": "#ACACAC",
  "puregray-450": "#919191",
  "puregray-50": "#F8F8F8",
  "puregray-500": "#767676",
  "puregray-550": "#5C5C5C",
  "puregray-600": "#434343",
  "puregray-650": "#393939",
  "puregray-700": "#303030",
  "puregray-750": "#272727",
  "puregray-800": "#1E1E1E",
  "puregray-850": "#181818",
  "puregray-900": "#131313",
  "puregray-950": "#080808",
  "red-100": "#FBDBD4",
  "red-200": "#FDB3A4",
  "red-25": "#FDF6F5",
  "red-300": "#FF8773",
  "red-400": "#FF4F40",
  "red-50": "#FCEEEA",
  "red-500": "#EB001F",
  "red-600": "#BC0117",
  "red-700": "#90000F",
  "red-75": "#FBE4DF",
  "red-800": "#650405",
  "red-900": "#340F05",
  "red-950": "#1F0B04",
  "sakurapink-100": "#FBD9EB",
  "sakurapink-200": "#FDAEDA",
  "sakurapink-25": "#FDF6F9",
  "sakurapink-300": "#FF7ECA",
  "sakurapink-400": "#FF38BB",
  "sakurapink-50": "#FCEDF4",
  "sakurapink-500": "#DE019F",
  "sakurapink-600": "#B2007F",
  "sakurapink-700": "#880060",
  "sakurapink-75": "#FBE3EF",
  "sakurapink-800": "#5F0443",
  "sakurapink-900": "#380626",
  "sakurapink-950": "#250419",
  "transparent": "transparent",
  "white": "#ffffff",
  "white-opacity-0": "#FFFFFF00",
  "white-opacity-10": "#FFFFFF19",
  "white-opacity-15": "#FFFFFF26",
  "white-opacity-20": "#FFFFFF33",
  "white-opacity-25": "#FFFFFF3F",
  "white-opacity-5": "#FFFFFF0C",
  "white-opacity-50": "#FFFFFF7F",
  "yellow-100": "#FFE284",
  "yellow-200": "#FFBF0B",
  "yellow-25": "#FFF9E0",
  "yellow-300": "#D8A100",
  "yellow-400": "#B78800",
  "yellow-50": "#FFF3C0",
  "yellow-500": "#977000",
  "yellow-600": "#785800",
  "yellow-700": "#5B4200",
  "yellow-75": "#FFEAA2",
  "yellow-800": "#3F2D00",
  "yellow-900": "#231A03",
  "yellow-950": "#161003",
  "yelloworange-100": "#FCDCC8",
  "yelloworange-200": "#FDB586",
  "yelloworange-25": "#FDF7F3",
  "yelloworange-300": "#FF8A35",
  "yelloworange-400": "#E46C00",
  "yelloworange-50": "#FCEEE6",
  "yelloworange-500": "#BD5800",
  "yelloworange-600": "#974500",
  "yelloworange-700": "#733300",
  "yelloworange-75": "#FBE5D7",
  "yelloworange-800": "#4E2402",
  "yelloworange-900": "#2A1705",
  "yelloworange-950": "#1A0E04",
  "action-downvote": {
    "light": "#6A5CFF",
    "dark": "#6A5CFF"
  },
  "action-upvote": {
    "light": "#D93900",
    "dark": "#D93900"
  },
  "ai-background-weaker": {
    "light": "#E7FDF5",
    "dark": "#00382B"
  },
  "ai-plain": {
    "light": "#006C56",
    "dark": "#01A484"
  },
  "ai-plain-hover": {
    "light": "#015140",
    "dark": "#00C29D"
  },
  "alert-caution": {
    "light": "#977000",
    "dark": "#977000"
  },
  "avatar-gradient": {
    "light": "",
    "dark": ""
  },
  "avatar-media-gradient": {
    "light": "",
    "dark": ""
  },
  "brand-background": {
    "light": "#D93900",
    "dark": "#D93900"
  },
  "brand-background-hover": {
    "light": "#AE2C00",
    "dark": "#AE2C00"
  },
  "brand-gradient-active": {
    "light": "",
    "dark": ""
  },
  "brand-gradient-active-highlight": {
    "light": "",
    "dark": ""
  },
  "brand-gradient-default": {
    "light": "",
    "dark": ""
  },
  "brand-gradient-default-highlight": {
    "light": "",
    "dark": ""
  },
  "brand-gradient-hover": {
    "light": "",
    "dark": ""
  },
  "brand-gradient-hover-highlight": {
    "light": "",
    "dark": ""
  },
  "brand-onBackground": {
    "light": "#FFFFFF",
    "dark": "#FFFFFF"
  },
  "category-live": {
    "light": "#D93900",
    "dark": "#D93900"
  },
  "category-nsfw": {
    "light": "#DE019F",
    "dark": "#DE019F"
  },
  "category-spoiler": {
    "light": "#131313",
    "dark": "#F2F2F2"
  },
  "caution-background": {
    "light": "#FFBF0B",
    "dark": "#D8A100"
  },
  "caution-background-hover": {
    "light": "#D8A100",
    "dark": "#FFBF0B"
  },
  "caution-onBackground": {
    "light": "#000000",
    "dark": "#000000"
  },
  "caution-plain": {
    "light": "#785800",
    "dark": "#FFBF0B"
  },
  "caution-plain-hover": {
    "light": "#5B4200",
    "dark": "#FFE284"
  },
  "danger-background": {
    "light": "#EB001F",
    "dark": "#BC0117"
  },
  "danger-background-disabled": {
    "light": "#FDB3A4",
    "dark": "#340F05"
  },
  "danger-background-hover": {
    "light": "#BC0117",
    "dark": "#EB001F"
  },
  "danger-background-weaker": {
    "light": "#FBDBD4",
    "dark": "#650405"
  },
  "danger-content": {
    "light": "#BC0117",
    "dark": "#FF4F40"
  },
  "danger-content-default": {
    "light": "#ffffff",
    "dark": "#ffffff"
  },
  "danger-content-hover": {
    "light": "#90000F",
    "dark": "#FF8773"
  },
  "danger-onBackground": {
    "light": "#FFFFFF",
    "dark": "#FFFFFF"
  },
  "danger-plain": {
    "light": "#BC0117",
    "dark": "#FF8773"
  },
  "danger-plain-hover": {
    "light": "#90000F",
    "dark": "#FDB3A4"
  },
  "downvote-background": {
    "light": "#6A5CFF",
    "dark": "#6A5CFF"
  },
  "downvote-background-disabled": {
    "light": "#6a5cff4d",
    "dark": "#6a5cff4d"
  },
  "downvote-background-hover": {
    "light": "#523DFF",
    "dark": "#523DFF"
  },
  "downvote-content": {
    "light": "#523DFF",
    "dark": "#9580FF"
  },
  "downvote-content-weak": {
    "light": "#6A5CFF",
    "dark": "#6A5CFF"
  },
  "downvote-disabled": {
    "light": "#523DFF4c",
    "dark": "#9580FF4c"
  },
  "downvote-onBackground": {
    "light": "#FFFFFF",
    "dark": "#FFFFFF"
  },
  "downvote-onStrongScrim": {
    "light": "#B29FFF",
    "dark": "#B29FFF"
  },
  "downvote-onStrongScrim-disabled": {
    "light": "#b29fff4d",
    "dark": "#b29fff4d"
  },
  "downvote-onStrongScrim-weaker": {
    "light": "#9580FF",
    "dark": "#9580FF"
  },
  "downvote-plain": {
    "light": "#523DFF",
    "dark": "#9580FF"
  },
  "downvote-plain-disabled": {
    "light": "#523dff4d",
    "dark": "#9580ff4d"
  },
  "downvote-plain-weaker": {
    "light": "#6A5CFF",
    "dark": "#6A5CFF"
  },
  "elevation-large1": {
    "light": "#0000003F",
    "dark": "#0000007F"
  },
  "elevation-large2": {
    "light": "#00000026",
    "dark": "#00000033"
  },
  "elevation-medium1": {
    "light": "#0000003F",
    "dark": "#0000007F"
  },
  "elevation-medium2": {
    "light": "#00000019",
    "dark": "#00000033"
  },
  "elevation-small": {
    "light": "#00000026",
    "dark": "#00000054"
  },
  "elevation-xsmall": {
    "light": "#0000003F",
    "dark": "#000000AA"
  },
  "favorite": {
    "light": "#977000",
    "dark": "#B78800"
  },
  "global-admin": {
    "light": "#D93900",
    "dark": "#D93900"
  },
  "global-alienblue": {
    "light": "#1870F4",
    "dark": "#1870F4"
  },
  "global-darkblue": {
    "light": "#2A3236",
    "dark": "#2A3236"
  },
  "global-focus": {
    "light": "Highlight",
    "dark": "Highlight"
  },
  "global-gold": {
    "light": "#B78800",
    "dark": "#D8A100"
  },
  "global-moderator": {
    "light": "#008A10",
    "dark": "#008A10"
  },
  "global-nsfw": {
    "light": "#DE019F",
    "dark": "#DE019F"
  },
  "global-offline": {
    "light": "#667780",
    "dark": "#667780"
  },
  "global-online": {
    "light": "#00C61C",
    "dark": "#00C61C"
  },
  "global-orangered": {
    "light": "#FF4500",
    "dark": "#FF4500"
  },
  "global-stars": {
    "light": "#977000",
    "dark": "#D8A100"
  },
  "gradient-media": {
    "light": "",
    "dark": ""
  },
  "gradient-media-strong": {
    "light": "",
    "dark": ""
  },
  "identity-admin": {
    "light": "#D93900",
    "dark": "#D93900"
  },
  "identity-coins": {
    "light": "#B78800",
    "dark": "#B78800"
  },
  "identity-moderator": {
    "light": "#008A10",
    "dark": "#008A10"
  },
  "identity-self": {
    "light": "#01876D",
    "dark": "#01876D"
  },
  "interactive-background-disabled": {
    "light": "#0000000C",
    "dark": "#FFFFFF0C"
  },
  "interactive-content-disabled": {
    "light": "#0000003F",
    "dark": "#FFFFFF3F"
  },
  "interactive-focused": {
    "light": "#007FAE",
    "dark": "#007FAE"
  },
  "interactive-pressed": {
    "light": "#00000026",
    "dark": "#FFFFFF26"
  },
  "inverted-interactive-background-disabled": {
    "light": "#FFFFFF0C",
    "dark": "#0000000C"
  },
  "inverted-interactive-content-disabled": {
    "light": "#FFFFFF3F",
    "dark": "#0000003F"
  },
  "inverted-interactive-pressed": {
    "light": "#FFFFFF26",
    "dark": "#00000026"
  },
  "inverted-neutral-background": {
    "light": "#0E1113",
    "dark": "#FFFFFF"
  },
  "inverted-neutral-background-hover": {
    "light": "#181C1F",
    "dark": "#F6F8F9"
  },
  "inverted-neutral-border": {
    "light": "#FFFFFF33",
    "dark": "#00000033"
  },
  "inverted-neutral-content": {
    "light": "#B7CAD4",
    "dark": "#333D42"
  },
  "inverted-neutral-content-strong": {
    "light": "#EEF1F3",
    "dark": "#181C1F"
  },
  "inverted-secondary-background": {
    "light": "#2A3236",
    "dark": "#E5EBEE"
  },
  "inverted-secondary-background-hover": {
    "light": "#333D42",
    "dark": "#DBE4E9"
  },
  "inverted-secondary-background-selected": {
    "light": "#3D494E",
    "dark": "#C9D7DE"
  },
  "inverted-secondary-onBackground": {
    "light": "#FFFFFF",
    "dark": "#000000"
  },
  "inverted-secondary-plain": {
    "light": "#DBE4E9",
    "dark": "#181C1F"
  },
  "inverted-secondary-plain-hover": {
    "light": "#FFFFFF",
    "dark": "#000000"
  },
  "media-background": {
    "light": "#00000099",
    "dark": "#00000099"
  },
  "media-background-hover": {
    "light": "#000000cc",
    "dark": "#000000cc"
  },
  "media-background-selected": {
    "light": "#000000cc",
    "dark": "#000000cc"
  },
  "media-border-selected": {
    "light": "#FFFFFF",
    "dark": "#FFFFFF"
  },
  "media-border-weak": {
    "light": "#FFFFFF19",
    "dark": "#FFFFFF19"
  },
  "media-onBackground": {
    "light": "#FFFFFF",
    "dark": "#FFFFFF"
  },
  "media-onBackground-disabled": {
    "light": "#FFFFFF3F",
    "dark": "#FFFFFF3F"
  },
  "media-onBackground-weak": {
    "light": "#E5EBEE",
    "dark": "#E5EBEE"
  },
  "media-onbackground": {
    "light": "#ffffff",
    "dark": "#ffffff"
  },
  "media-onbackground-disabled": {
    "light": "#ffffff3f",
    "dark": "#ffffff3f"
  },
  "media-onbackground-weak": {
    "light": "#B7CAD4",
    "dark": "#B7CAD4"
  },
  "neutral-background": {
    "light": "#FFFFFF",
    "dark": "#0E1113"
  },
  "neutral-background-container": {
    "light": "#F6F8F9",
    "dark": "#181C1F"
  },
  "neutral-background-container-hover": {
    "light": "#EEF1F3",
    "dark": "#21272A"
  },
  "neutral-background-container-strong": {
    "light": "#EEF1F3",
    "dark": "#21272A"
  },
  "neutral-background-container-strong-hover": {
    "light": "#E5EBEE",
    "dark": "#2A3236"
  },
  "neutral-background-gilded": {
    "light": "#FFF9E0",
    "dark": "#181C1F"
  },
  "neutral-background-gilded-hover": {
    "light": "#FFF3C0",
    "dark": "#21272A"
  },
  "neutral-background-highlighted": {
    "light": "#F6F8F9",
    "dark": "#181C1F"
  },
  "neutral-background-highlighted-strong": {
    "light": "#FFF9E0",
    "dark": "#2A3236"
  },
  "neutral-background-hover": {
    "light": "#F6F8F9",
    "dark": "#181C1F"
  },
  "neutral-background-medium": {
    "light": "#F8F8F8",
    "dark": "#131313"
  },
  "neutral-background-pinned": {
    "light": "#FFFFFF",
    "dark": "#0E1113"
  },
  "neutral-background-selected": {
    "light": "#E5EBEE",
    "dark": "#2A3236"
  },
  "neutral-background-strong": {
    "light": "#FFFFFF",
    "dark": "#181C1F"
  },
  "neutral-background-strong-hover": {
    "light": "#F6F8F9",
    "dark": "#21272A"
  },
  "neutral-background-weak": {
    "light": "#F6F8F9",
    "dark": "#000000"
  },
  "neutral-background-weak-hover": {
    "light": "#EEF1F3",
    "dark": "#0E1113"
  },
  "neutral-border": {
    "light": "#00000033",
    "dark": "#FFFFFF33"
  },
  "neutral-border-medium": {
    "light": "#0000007F",
    "dark": "#FFFFFF7F"
  },
  "neutral-border-strong": {
    "light": "#181C1F",
    "dark": "#F6F8F9"
  },
  "neutral-border-weak": {
    "light": "#00000019",
    "dark": "#FFFFFF19"
  },
  "neutral-content": {
    "light": "#333D42",
    "dark": "#B7CAD4"
  },
  "neutral-content-disabled": {
    "light": "#D6D6D6",
    "dark": "#303030"
  },
  "neutral-content-strong": {
    "light": "#181C1F",
    "dark": "#EEF1F3"
  },
  "neutral-content-weak": {
    "light": "#5C6C74",
    "dark": "#8BA2AD"
  },
  "offline": {
    "light": "#767676",
    "dark": "#767676"
  },
  "online": {
    "light": "#01A816",
    "dark": "#01A816"
  },
  "opacity-08": {
    "light": "#13131314",
    "dark": "#13131314"
  },
  "opacity-50": {
    "light": "#0000007f",
    "dark": "#F2F2F27f"
  },
  "opacity-highlight": {
    "light": "",
    "dark": ""
  },
  "pizzaRed": {
    "light": "#ef5350",
    "dark": "#c62828"
  },
  "primary": {
    "light": "#115BCA",
    "dark": "#648EFC"
  },
  "primary-background": {
    "light": "#0A449B",
    "dark": "#115BCA"
  },
  "primary-background-hover": {
    "light": "#0A2F6C",
    "dark": "#1870F4"
  },
  "primary-background-selected": {
    "light": "#0A1A3F",
    "dark": "#648EFC"
  },
  "primary-border": {
    "light": "#0A449B",
    "dark": "#648EFC"
  },
  "primary-border-hover": {
    "light": "#0A2F6C",
    "dark": "#90A9FD"
  },
  "primary-hover": {
    "light": "#0A449B",
    "dark": "#90A9FD"
  },
  "primary-onBackground": {
    "light": "#FFFFFF",
    "dark": "#FFFFFF"
  },
  "primary-onBackground-selected": {
    "light": "#FFFFFF",
    "dark": "#000000"
  },
  "primary-plain": {
    "light": "#0A449B",
    "dark": "#648EFC"
  },
  "primary-plain-hover": {
    "light": "#0A2F6C",
    "dark": "#90A9FD"
  },
  "primary-plain-visited": {
    "light": "#7600A3",
    "dark": "#CF5FFF"
  },
  "primary-visited": {
    "light": "#9B00D4",
    "dark": "#CF5FFF"
  },
  "scrim": {
    "light": "#00000099",
    "dark": "#00000099"
  },
  "scrim-background": {
    "light": "#00000099",
    "dark": "#00000099"
  },
  "scrim-background-strong": {
    "light": "#000000CC",
    "dark": "#000000CC"
  },
  "scrim-gradient": {
    "light": "",
    "dark": ""
  },
  "scrim-strong": {
    "light": "#000000cc",
    "dark": "#000000cc"
  },
  "secondary": {
    "light": "#21272A",
    "dark": "#DBE4E9"
  },
  "secondary-background": {
    "light": "#E5EBEE",
    "dark": "#2A3236"
  },
  "secondary-background-hover": {
    "light": "#DBE4E9",
    "dark": "#333D42"
  },
  "secondary-background-selected": {
    "light": "#C9D7DE",
    "dark": "#3D494E"
  },
  "secondary-hover": {
    "light": "#000000",
    "dark": "#ffffff"
  },
  "secondary-onBackground": {
    "light": "#000000",
    "dark": "#FFFFFF"
  },
  "secondary-plain": {
    "light": "#181C1F",
    "dark": "#DBE4E9"
  },
  "secondary-plain-hover": {
    "light": "#000000",
    "dark": "#FFFFFF"
  },
  "secondary-plain-weak": {
    "light": "#5C6C74",
    "dark": "#8BA2AD"
  },
  "secondary-weak": {
    "light": "#576F76",
    "dark": "#748791"
  },
  "success-background": {
    "light": "#008A10",
    "dark": "#016E0B"
  },
  "success-background-hover": {
    "light": "#016E0B",
    "dark": "#008A10"
  },
  "success-content": {
    "light": "#016E0B",
    "dark": "#01A816"
  },
  "success-hover": {
    "light": "#005306",
    "dark": "#00C61C"
  },
  "success-onBackground": {
    "light": "#FFFFFF",
    "dark": "#FFFFFF"
  },
  "success-plain": {
    "light": "#016E0B",
    "dark": "#00C61C"
  },
  "success-plain-hover": {
    "light": "#005306",
    "dark": "#58E15B"
  },
  "tone-1": {
    "light": "#131313",
    "dark": "#F2F2F2"
  },
  "tone-2": {
    "light": "#434343",
    "dark": "#ACACAC"
  },
  "tone-3": {
    "light": "#ACACAC",
    "dark": "#434343"
  },
  "tone-4": {
    "light": "#E4E4E4",
    "dark": "#303030"
  },
  "tone-5": {
    "light": "#F2F2F2",
    "dark": "#1E1E1E"
  },
  "tone-6": {
    "light": "#F8F8F8",
    "dark": "#131313"
  },
  "tone-7": {
    "light": "#ffffff",
    "dark": "#080808"
  },
  "transparent-background-hover": {
    "light": "#74879119",
    "dark": "#66778019"
  },
  "ui-canvas": {
    "light": "#F2F2F2",
    "dark": "#080808"
  },
  "ui-modalbackground": {
    "light": "#FFFFFF",
    "dark": "#181C1F"
  },
  "upvote-background": {
    "light": "#D93900",
    "dark": "#D93900"
  },
  "upvote-background-disabled": {
    "light": "#d939004d",
    "dark": "#d939004d"
  },
  "upvote-background-hover": {
    "light": "#AE2C00",
    "dark": "#AE2C00"
  },
  "upvote-content": {
    "light": "#AE2C00",
    "dark": "#FF4500"
  },
  "upvote-content-weak": {
    "light": "#FF4500",
    "dark": "#FF4500"
  },
  "upvote-disabled": {
    "light": "#AE2C004c",
    "dark": "#FF45004c"
  },
  "upvote-onBackground": {
    "light": "#FFFFFF",
    "dark": "#FFFFFF"
  },
  "upvote-onStrongScrim": {
    "light": "#FF895D",
    "dark": "#FF895D"
  },
  "upvote-onStrongScrim-disabled": {
    "light": "#ff895d4d",
    "dark": "#ff895d4d"
  },
  "upvote-onStrongScrim-weaker": {
    "light": "#FF4500",
    "dark": "#FF4500"
  },
  "upvote-plain": {
    "light": "#AE2C00",
    "dark": "#FF895D"
  },
  "upvote-plain-disabled": {
    "light": "#ae2c004d",
    "dark": "#ff895d4d"
  },
  "upvote-plain-weaker": {
    "light": "#FF4500",
    "dark": "#FF4500"
  },
  "warning-background": {
    "light": "#B78800",
    "dark": "#B78800"
  },
  "warning-background-hover": {
    "light": "#977000",
    "dark": "#D8A100"
  },
  "warning-content": {
    "light": "#785800",
    "dark": "#B78800"
  },
  "warning-content-hover": {
    "light": "#5B4200",
    "dark": "#D8A100"
  },
  "warning-onBackground": {
    "light": "#000000",
    "dark": "#000000"
  }
};
